module.exports = __webpack_public_path__ + "static/media/ratEnemy.abc690c4.jpg";